<div class="section is-fullheight">
  <div class="container">
    <div class="column is-6-desktop is-offset-3-desktop">
      <PopupBtn />
      <Heading />
      <div class="box mt-6">
        <form on:submit|preventDefault="{formSubmit}">
          <div class="field is-horizontal mt-3">
            <div class="field-label is-normal">
              <label class="label">Clubname</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input
                    class="input"
                    type="text"
                    placeholder="Golfclub Hasenheide"
                    autofocus=""
                    bind:value="{name}"
                    disabled="{processingLogin}"
                  />
                </p>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">Name</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input
                    class="input"
                    type="text"
                    placeholder="Max Mustermann"
                    bind:value="{username}"
                    disabled="{processingLogin}"
                  />
                </p>
              </div>
            </div>
          </div>

          <div class="mb-5">
            Mit dem Klick auf
            <i>Demo starten</i>
            erklärst du dich mit unserer
            <a
              on:click="{() => push('/datenschutz')}"
              class="is-link"
            >Datenschutzerklärung</a>
            einverstanden.
          </div>
          <div class="has-text-right">
            <button
              class="button is-block is-outline is-medium is-fullwidth {processingLogin ? 'is-loading' : ''}"
              disabled="{processingLogin}"
            >Demo starten</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <FooterNav />
</div>

<script>
import { onMount } from "svelte";

import { push } from "svelte-spa-router";
import FooterNav from "./FooterNav.svelte";
import PopupBtn from "./general/PopupBtn.svelte";
import Heading from "./Heading.svelte";
import { demoSvc } from "./services/demo.service";
import { demoSetup } from "./stores";

let name, username, processingLogin, demoData;

const formSubmit = () => {
  processingLogin = true;
  setTimeout(() => {
    if (name && username) {
      demoSetup.set({ name, username });
      push("/login");
    }

    processingLogin = false;
  }, 500);
};

demoSetup.subscribe((value) => {
  demoData = value;
  if (demoData?.name && demoData?.username) {
    push("/login");
  }
});

onMount(() => {
  if (demoSvc.isLiveInstance()) {
    push("/login");
  }
});
</script>

<style type="text/scss">
.box {
  margin-top: 5rem;
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.login-hr {
  border-bottom: 1px solid black;
}

.has-text-black {
  color: black;
}

.field {
  padding-bottom: 10px;
}

.fa {
  margin-left: 5px;
}
</style>
